/* eslint-disable react/display-name */
import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from 'react'
import { Box, RadioButtonIcon, Wrapper } from './styles'

type Props = {
  'data-qa'?: string
  checked?: boolean
  children?: any
  disabled?: boolean
  name?: string
  onChange: Function
  style?: object
  theme?: 'negative' | 'selected' | 'unselected'
  value?: string
}

type refFunctions = {
  check: (value?: boolean) => void
  value: boolean
}

const RadioButton = forwardRef<refFunctions | null, Props>(
  (props: Props, ref) => {
    const [isChecked, setIsChecked] = useState<boolean>(props.checked || false)
    const theme = composeTheme(isChecked, props.theme)

    function handleClass() {
      return `${theme} ${props.disabled ? 'is-disabled' : ''}`
    }

    function handleIcon(theme) {
      if (theme !== 'negative') {
        return <RadioButtonIcon className={handleClass()} />
      }
    }

    useImperativeHandle(ref, () => ({
      check: (value?: boolean) => {
        setIsChecked(value !== undefined ? value : !isChecked)
      },
      value: isChecked,
    }))

    useEffect(() => {
      props.checked !== undefined && setIsChecked(props.checked)
    }, [props.checked])

    return (
      <Wrapper className={handleClass()}>
        <Box
          className={handleClass()}
          onClick={(e) => {
            e.stopPropagation()
            setIsChecked(!isChecked)
            props.onChange()
          }}
        >
          <input
            type="radio"
            checked={isChecked}
            style={{ display: 'none' }}
            value={props.value}
            name={props.name}
            readOnly
            data-qa={props['data-qa'] || `radio-${props.theme}`}
          />

          {handleIcon(theme)}
        </Box>

        <label htmlFor={props.name}>{props.children}</label>
      </Wrapper>
    )
  },
)

export default RadioButton

RadioButton.defaultProps = {
  checked: false,
  disabled: false,
  theme: 'unselected',
}

export function composeTheme(isChecked: boolean, theme: string): string {
  return isChecked ? 'selected' : theme
}
